import React from 'react';

const ThreeDotsIcon = () =>
  (<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" width="21px" height="13px">
    <path className="icon-wrap" d="M3.9,11.1C1.7,11.1,0,12.9,0,15c0,2.1,1.7,3.9,3.9,3.9c2.1,0,3.9-1.7,3.9-3.9C7.8,12.9,6,11.1,3.9,11.1z M15,11.1c-2.1,0-3.9,1.7-3.9,3.9c0,2.1,1.7,3.9,3.9,3.9c2.1,0,3.9-1.7,3.9-3.9C18.9,12.9,17.1,11.1,15,11.1z M26.1,11.1 c-2.1,0-3.9,1.7-3.9,3.9c0,2.1,1.7,3.9,3.9,3.9c2.1,0,3.9-1.7,3.9-3.9C30,12.9,28.3,11.1,26.1,11.1z" />
  </svg>);

export default ThreeDotsIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ThreeDotsIcon.js